import { MapfreLoadingComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-loading/mapfre-loading.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { PaymentServiceService } from '../../../../../_services/payment-service/payment-service.service';
import { StorageServiceObservablesService } from '../../../../../_services/storage-service-observables/storage-service-observables.service';
import { environment } from '@env/environment';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { BillingPaymentService } from '../../../../../_services/my-insurance/billing-payment.service';
import { Router , RouterModule } from '@angular/router';
import { ErrorRedirectionService } from '../../../../../_services/error-service/error-redirection.service';
import { ClaimsService } from '../../../../../_services/_claims/claims.service';
import { Location } from '@angular/common';
import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';
import { UrlValidationService } from '@services/document/url-validation.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreLoadingComponent],
  selector: 'app-paymentus-card',
  templateUrl: './paymentus-card.component.html',
})
export class PaymentusCardComponent implements OnInit {
  paymentUsURL: any = '';
  loading = false;
  isAcmic: boolean;

  constructor(
    private paymentService: PaymentServiceService,
    private storageService: StorageServiceObservablesService,
    private errorRedirection: ErrorRedirectionService,
    private billingPaymentService: BillingPaymentService,
    private router: Router,
    private claimsService: ClaimsService,
    private location: Location,
    private acmicService: AcmicService,
    private urlValidationService: UrlValidationService
  ) {}

  ngOnInit(): void {
    this.detectStateCode();
    this.loading = true;

    if (this.router.url == '/my-insurance/reportClaim') {
      this.claimsService.reportAClaim().subscribe((url) => {
        if (this.urlValidationService.isApprovedRedirectUrl(url)) {
        const link = document.createElement('a');
        link.href = url;
        if (Capacitor.isNativePlatform()) {
          Browser.open({ url });
        } else {
          link.click();
        }
        this.goBack();
      }
      });
    } else if (this.router.url == '/my-insurance/payment/wallet') {
      this.paymentService
        .paymentWallet(this.storageService.getUserFromStorage())
        .subscribe((token) => {
          const link = document.createElement('a');
          link.href = `${environment.paymentus_wallet}${token}&brand=${
            this.isAcmic ? 'AAA' : 'MAPFRE'
          }`;
          if (this.urlValidationService.isApprovedRedirectUrl(link.href)) {
          if (this.urlValidationService.isApprovedRedirectUrl(link.href)){
          if (Capacitor.isNativePlatform()) {
            Browser.open({
              url: `${environment.paymentus_wallet}${token}&brand=${
                this.isAcmic ? 'AAA' : 'MAPFRE'
              }`,
            });
          } else {
            link.click();
          }
          this.goBack();
        }
      }
    });
    } else {
      const paymentData = this.paymentService.getPaymentData().split('|');

      const policyNumber = atob(paymentData[0]) || '';
      const zipCode = atob(paymentData[1]) || '';
      const amount = atob(paymentData[2]) || '';

      if (policyNumber.length === 10) {
        this.paymentService
          .paymentUser(this.storageService.getUserFromStorage(), policyNumber)
          .subscribe(
            (token) => {
              this.paymentUsURL = `${
                environment.paymentus_account
              }${token}&brand=${this.isAcmic ? 'AAA' : 'MAPFRE'}`;
              const link = document.createElement('a');
              link.href = `${environment.paymentus_account}${token}&brand=${
                this.isAcmic ? 'AAA' : 'MAPFRE'
              }`;
              if (this.urlValidationService.isApprovedRedirectUrl(link.href)){
              if (Capacitor.isNativePlatform()) {
                Browser.open({
                  url: `${environment.paymentus_account}${token}&brand=${
                    this.isAcmic ? 'AAA' : 'MAPFRE'
                  }`,
                });
              } else {
                link.click();
              }
              this.goBack();
            }
          },
            (err) => {
              this.errorRedirection.redirect(err.status);
            }
          );
      } else {
        this.billingPaymentService.makePayment(policyNumber, zipCode, amount);
      }
    }
  }

  detectStateCode() {
    this.isAcmic = this.acmicService.isACMIC();
  }

  goBack() {
    if (Capacitor.isNativePlatform()) {
      this.location.back();
    }
  }
}
